import styled from "styled-components"

interface IButton {
    icon: any;
    actionButon: () => void;
}

export default function ActionButtonIcon({ icon, actionButon}: IButton) {
    return (
        <Container onClick={actionButon}>
            {icon}
        </Container>
    )
}

const Container = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;

    /* padding: 8px 12px; */
    padding: 8px;
    /* width: 36px;
    height: 36px; */
    border-radius: 100px;
    
    box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 1px;
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.white};
    
    font-weight: bold;
    font-size: 16px;

    &:hover{
        background-color: ${(props) => props.theme.colors.red.red_800};
    }
`;